import { path } from "../utils/data";

const Path = () => (
  <section
    id="path"
    className="scroll-mt-20 border-b border-paper-300 py-24 lg:py-32"
  >
    <div className="mx-auto max-w-shell px-6 lg:px-10">
      <div className="mb-14">
        <p className="eyebrow eyebrow-dot">{path.eyebrow}</p>
        <h2 className="display mt-5 text-display-md text-ink-950">
          {path.heading}
        </h2>
      </div>

      {/* Single rail, work and study on the same line */}
      <ol className="relative">
        <span
          aria-hidden
          className="absolute left-[19px] top-2 bottom-2 w-px bg-paper-300 md:left-[calc(11rem+52px)]"
        />

        {path.timeline.map((item) => (
          <li
            key={`${item.org}-${item.title}`}
            className="relative flex gap-6 pb-12 last:pb-0 md:gap-8"
          >
            {/* Date rail (desktop) */}
            <p className="hidden w-44 shrink-0 pt-2 text-right font-mono text-micro uppercase text-ink-500 md:block">
              {item.date}
            </p>

            {/* Node — a small marker sitting on the rail, no icon */}
            <span
              aria-hidden
              className="relative z-10 mt-1.5 flex h-10 w-10 shrink-0 items-center justify-center"
            >
              <span
                className={`h-2.5 w-2.5 border transition-colors duration-200 ${
                  item.current
                    ? "border-clay bg-clay"
                    : "border-paper-400 bg-white"
                }`}
              />
            </span>

            {/* Body */}
            <div className="min-w-0 flex-1 pt-1">
              <div className="flex flex-wrap items-center gap-3">
                <h3 className="display text-xl tracking-tight text-ink-950 sm:text-2xl">
                  {item.title}
                </h3>
                {item.current && (
                  <span className="bg-clay-soft px-2.5 py-1 font-mono text-micro uppercase text-clay-dim">
                    Current
                  </span>
                )}

                {item.cgpa && (
                  <span className="bg-clay-soft px-2.5 py-1 font-mono text-micro uppercase text-clay-dim">
                    CGPA {item.cgpa}
                  </span>
                )}
              </div>

              <p className="mt-1.5 text-body text-clay-dim">
                {item.org}
              </p>

              <p className="mt-1 font-mono text-micro uppercase text-ink-500 md:hidden">
                {item.date}
              </p>
              <p className="mt-1 text-sm text-ink-500">{item.meta}</p>

              {item.points.length > 0 && (
                <ul className="mt-5 space-y-2.5">
                  {item.points.map((p) => (
                    <li
                      key={p}
                      className="flex gap-3 text-sm leading-relaxed text-ink-600"
                    >
                      <span
                        aria-hidden
                        className="mt-[0.4rem] h-1.5 w-1.5 shrink-0 rounded-full bg-clay"
                      />
                      {p}
                    </li>
                  ))}
                </ul>
              )}

              {/* Dot-separated rather than chips: the timeline is dense
                  already, and boxed chips here compete with the project
                  cards. */}
              {item.tech.length > 0 && (
                <div className="mt-5 flex flex-wrap items-center gap-x-2.5 gap-y-1.5">
                  {item.tech.map((t, ti) => (
                    <span key={t} className="flex items-center gap-2.5">
                      {ti > 0 && (
                        <span
                          aria-hidden
                          className="h-1 w-1 shrink-0 rounded-full bg-clay/70"
                        />
                      )}
                      <span className="font-mono text-micro uppercase text-ink-500">
                        {t}
                      </span>
                    </span>
                  ))}
                </div>
              )}
            </div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);

export default Path;
